import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, useTheme } from '@mui/material';
import useTextFieldStyles from './useTextFieldStyles';
import { ArrowDown2 } from 'iconsax-react';
import { BranchedIndicator } from '../BranchedIndicator';
export const POutlinedField = ({ children, type = 'text', parentOptionId, parentFieldLabel, parentOptionLabel }) => {
    const styles = useTextFieldStyles();
    const theme = useTheme();
    return (_jsxs(Box, { sx: {
            ...styles,
            height: type === 'multiline' ? 135 : 'auto',
            pt: type === 'multiline' ? 2 : 0,
            position: 'relative',
            alignItems: type === 'multiline' ? 'start' : 'center',
            paddingRight: type === 'select'
                ? (parentOptionId || parentFieldLabel || parentOptionLabel ? 2 : 4)
                : 2,
            display: 'flex',
            gap: 0.5
        }, children: [_jsxs(Box, { sx: { flex: 1, minWidth: 0, position: 'relative' }, children: [_jsx("div", { style: { paddingRight: type === 'select' ? '8px' : undefined }, children: children || 'Text Field Preview' }), type === 'select' && (_jsx(ArrowDown2, { size: 14, style: {
                            position: 'absolute',
                            right: 12,
                            strokeWidth: 2,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: alpha(theme.palette.action.disabled, 0.8),
                            pointerEvents: 'none'
                        } }))] }), _jsx(BranchedIndicator, { parentOptionId: parentOptionId, parentFieldLabel: parentFieldLabel, parentOptionLabel: parentOptionLabel })] }));
};
